var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAssignHistory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.50033 7.10417H3.43783C2.79819 7.10417 2.47837 7.10417 2.21814 7.18309C1.6322 7.36083 1.17368 7.8194 0.995936 8.40533C0.916992 8.66557 0.916992 8.98535 0.916992 9.625M8.70866 9.625V6.875M7.33366 8.25H10.0837M6.64616 3.4375C6.64616 4.57659 5.72275 5.5 4.58366 5.5C3.44457 5.5 2.52116 4.57659 2.52116 3.4375C2.52116 2.29841 3.44457 1.375 4.58366 1.375C5.72275 1.375 6.64616 2.29841 6.64616 3.4375Z",
    stroke: "#4F46E5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignHistory);
export default __webpack_public_path__ + "static/media/assign_history.ae189d700eb6864963da59dd38cb31d2.svg";
export { ForwardRef as ReactComponent };